export default function DeliverablesPanel() {
  const deliverables = [
    {
      title: 'Visual Inspection',
      icon: 'ri-camera-line',
      color: 'blue',
      items: [
        'High-resolution photo set or map',
        'Annotated findings',
        'Issue locations + summary notes',
      ],
    },
    {
      title: 'Thermal Inspection',
      icon: 'ri-temp-hot-line',
      color: 'orange',
      items: [
        'Thermal map',
        'Hot-spot list with location pins',
        'Priority summary for maintenance',
      ],
    },
    {
      title: 'Full Diagnostic Package',
      icon: 'ri-file-chart-line',
      color: 'emerald',
      items: [
        'Thermal + RGB deliverables',
        'Defect categories + severity ranking',
        'Executive summary PDF + recommended next steps',
      ],
    },
  ];

  return (
    <div className="mt-12">
      <h3 className="text-2xl font-bold text-stone-900 mb-8 text-center">What You Get</h3>
      
      <div className="grid md:grid-cols-3 gap-6">
        {deliverables.map((service, index) => (
          <div key={index} className="bg-white rounded-lg border border-stone-200 p-6">
            <div className={`w-12 h-12 bg-${service.color}-100 rounded-lg flex items-center justify-center mb-4`}>
              <i className={`${service.icon} text-2xl text-${service.color}-700`}></i>
            </div>
            <h4 className="text-lg font-bold text-stone-900 mb-4">{service.title}</h4>
            <ul className="space-y-2">
              {service.items.map((item, idx) => (
                <li key={idx} className="flex items-start gap-2 text-sm text-stone-600">
                  <i className="ri-check-line text-emerald-600 mt-0.5 flex-shrink-0"></i>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
